export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-page-export-pdf-a9f76d07e6a1b7339009c41fdd3c3f75.svg";